
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Progress } from '@/components/ui/progress';
import { Download } from 'lucide-react';
import { format as formatDate } from 'date-fns';
import { ExportRequest } from './types/export';

interface ExportHistoryListProps {
  exportRequests: ExportRequest[];
}

const ExportHistoryList: React.FC<ExportHistoryListProps> = ({ exportRequests }) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'completed': return 'bg-white text-green-800';
      case 'processing': return 'bg-white text-black';
      case 'failed': return 'bg-red-100 text-red-800';
      default: return 'bg-white text-black';
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Export History</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {exportRequests?.map((request) => (
            <div key={request.id} className="flex items-center justify-between p-4 border rounded-lg">
              <div className="space-y-1">
                <div className="flex items-center gap-2">
                  <span className="font-medium">{request.exportType} Export</span>
                  <Badge className={getStatusColor(request.status)}>
                    {request.status}
                  </Badge>
                </div>
                <p className="text-sm text-black">
                  Created {formatDate(new Date(request.createdAt), 'PPp')}
                </p>
                {request.status === 'processing' && (
                  <Progress value={request.progress} className="w-32" />
                )}
              </div>
              {request.downloadUrl && request.status === 'completed' && (
                <Button variant="outline" size="sm">
                  <Download className="h-4 w-4 mr-2" />
                  Download
                </Button>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ExportHistoryList;
